import Index from "../../pages/snail/anniversaryBadge/index";
import Query from "../../pages/snail/anniversaryBadge/query"
import Pc from "../../pages/snail/anniversaryBadge/pc";

const base = "anniversaryBadge";

const routes = [{
        path: `/${base}/index`,
        name: `${base}-index`,
        component: Index
    },
    {
        path: `/${base}/enter*`,
        name: `${base}-enter`,
        component: Index
    },
    {
        path: `/${base}/query*`,
        name: `${base}-query`,
        component: Query
    },
    {
        path: `/${base}/pc`,
        name: `${base}-pc`,
        component: Pc
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/anniversaryBadge.js